export default class SocialHelper {
	static getBusinessUrl (slug: string) {
		return `https://www.bizzey/businesses/${slug}`
	}
}